export default __webpack_public_path__ + "static/media/Coil.e8e7b11b.png";